import React from 'react';
import '../assets/FamilyStatsSummary.css';
import { formatCurrency } from '../utils/currencyUtils';

/**
 * FamilyStatsSummary Component
 * 
 * Displays aggregated statistics at the top of family view
 * Validates: Requirements 2.2, 2.4, 9.1, 9.2, 9.3
 * 
 * @param {Object} props
 * @param {number} props.totalFamilies - Total number of families
 * @param {number} props.totalTutees - Total number of tutees across all families
 * @param {number} props.totalActiveSubjects - Total number of active subjects
 * @param {number} props.totalMonthlyRevenue - Combined average monthly revenue (6-month average) across all families
 */
const FamilyStatsSummary = ({
  totalFamilies,
  totalTutees,
  totalActiveSubjects,
  totalMonthlyRevenue
}) => {
  return (
    <div className="family-stats-summary">
      <div className="stat-card">
        <div className="stat-value">{totalFamilies}</div>
        <div className="stat-label">Total Families</div>
      </div>
      
      <div className="stat-card">
        <div className="stat-value">{totalTutees}</div>
        <div className="stat-label">Total Tutees</div>
      </div>
      
      <div className="stat-card">
        <div className="stat-value">{totalActiveSubjects}</div>
        <div className="stat-label">Active Subjects</div>
      </div>
      
      <div className="stat-card">
        <div className="stat-value">{formatCurrency(totalMonthlyRevenue)}</div>
        <div className="stat-label">Combined Avg Monthly Revenue (6-mo)</div>
      </div>
    </div>
  );
};

export default FamilyStatsSummary;
